export default {
  0: { label: "테스트페이지" },
  53: { label: "사고조사 보고서", isApproval: true },
  54: { label: "사고경위서" },
  55: { label: "목격자 진술서" },
  56: { label: "실험실 안전사고 보고", isApproval: true },
  57: { label: "산업재해조사표" },
  58: { label: "산업안전보건위원회" },
  59: { label: "안전경영위원회" },
  60: { label: "안전근로협의체" },
  61: { label: "안전보건협의체" },
  62: { label: "아차사고 사례 카드" },
  63: { label: "아차사고 사례 개선 확인 카드" },
  64: { label: "실험실 일상 점검표" },
  65: { label: "실험실 정기 점검표" },
  66: { label: "TAC 안전관리 점검표" },
  67: { label: "밀폐공간 작업프로그램 평가표" },
  68: { label: "밀폐공간 작업 전 체크리스트" },
  69: { label: "고압가스 충전실 안전점검표" },
  70: { label: "한수단 2호 안전점검표" },
  71: { label: "잠수 운용 계획서" },
  72: { label: "잠수작업 전 안전점검표" },
  73: { label: "잠수 운용 결과서" },
  74: { label: "중량물·운반기계 안전점검표", isApproval: true },
  75: { label: "작업장 안전점검표", isApproval: true },
  76: { label: "안전", isApproval: true },
  77: { label: "보건", isApproval: true },
  78: { label: "공단임직원", useListGetCompanyName: true },
  79: { label: "수급업체 근로자", useListGetCompanyName: true },
  80: { label: "공단임직원" },
  81: { label: "수급업체 근로자" },
  82: { label: "정기 위험성 평가", isApproval: true },
  83: { label: "수시 위험성 평가", isApproval: true },
  84: { label: "작업수행부서", isApproval: true },
  85: { label: "수급업체", isApproval: true },
  86: { label: "안전·보건예산 현황", isApproval: true, useHeaderDate: true },
  87: { label: "기타", useListGetCompanyName: true },
  88: { label: "기타" },
  89: { label: "사업장 정보", usePrint: false },

  100: { label: "작업장 합동점검", isApproval: false, usePrint: true },
  101: { label: "안전·보건 경영방침", usePrint: true },
  102: { label: "안전보건총괄책임자 업무 수행평가", isApproval: false, usePrint: true },
  103: { label: "직접수행 사업장", isApproval: true, usePrint: true },
  104: { label: "소속부서 및 담당업체 정보", isApproval: false, usePrint: true },
  105: { label: "수급업체 등록 요청", isApproval: false, usePrint: true },
  106: { label: "안전·보건 예산", usePrint: true, useHeaderDate: true },
  107: { label: "안전·보건교육", isApproval: false, usePrint: true, hidePrintTitle: true, usePrevPost: true },
  108: { label: "안전보건", isApproval: false, usePrint: true },
  109: { label: "사업장 안전·보건 경영방침", isApproval: false, usePrint: true },
  110: { label: "도로 보수", isApproval: false, usePrint: true },
  111: { label: "사업장(안전보건 예산(C형))", isApproval: true, usePrint: true },
  112: { label: "건설현장 일반관리", isApproval: false, usePrint: true },
  113: { label: "수영장", isApproval: false, usePrint: true },
  114: { label: "시설물 점검", isApproval: false, usePrint: true },
  115: { label: "시설물 관리", isApproval: true, usePrint: true },
  116: { label: "(재해발생) 산업재해 발생 시 보고 절차 안내", isApproval: false, usePrint: true },
  117: { label: "산업재해조사표", isApproval: false, usePrint: true, hidePrintTitle: true },
  118: { label: "계약정보", isApproval: true, usePrint: true },

  119: { label: "안전보건총괄책임자 선임", usePrint: true },
  120: { label: "중대재해예방팀 선임", usePrint: true },
  121: { label: "안전보건조정자 선임", usePrint: true },
  122: { label: "안전보건관리자 및 산업보건의 선임", usePrint: true },
  123: { label: "안전보건관리자 및 산업보건의(건설업) 선임", usePrint: true },
  124: { label: "안전보건담당자 선임", usePrint: true },
  125: { label: "관리감독자 선임", usePrint: true },
  126: { label: "안전·보건 조직 체계도", usePrint: true },

  127: { label: "안전보건관리책임자 업무 수행평가", isApproval: false, usePrint: true },
  128: { label: "관리감독자 업무 수행평가", isApproval: false, usePrint: true },
  129: { label: "종사자 참여 평가", isApproval: false, usePrint: true },
  130: { label: "수급업체 수행평가", isApproval: false, usePrint: true },
  131: { label: "수시 점검표", usePrint: true },

  132: { label: "교육 모니터링", isApproval: true, usePrint: true },
  133: { label: "월별 보고", isApproval: true, usePrint: true },
  134: { label: "반기별 보고", usePrint: true, useHeaderDate: true, headerDateType: "year" },

  135: { label: "소속부서 및 담당업체 정보", isApproval: true, usePrint: true },
  136: { label: "안전보건 점검 인력", usePrint: true },
  137: { label: "안전·보건 점검 계획", usePrint: true, listType: "list137" },
  138: { label: "비상 연락/지원 체계도", usePrint: true },
  139: { label: "유관기관 비상연락망", usePrint: true, hidePrintTitle: true },
  140: { label: " 안전·보건관리체계 구축 현황(중대산업재해)", isApproval: false, usePrint: true },
  141: { label: "안전보건 조직도", usePrint: true },
  142: { label: "종사자 정보", isApproval: false, usePrint: true },

  143: { label: "도급전 정보 제공", isApproval: false, usePrint: true },
  144: { label: "기본안전보건대장", isApproval: false, usePrint: true },
  145: { label: "설계안전보건대장", isApproval: false, usePrint: true },
  146: { label: "공사안전보건대장", isApproval: false, usePrint: true },
  147: { label: "설계변경 요청", isApproval: false, usePrint: true },
  148: { label: "건설공사 기간 연장", isApproval: false, usePrint: true },
  149: { label: "수급인 산재예방 평가", usePrint: true },
  150: { label: "안전·보건 확보 의무", usePrint: true, useHeaderDate: true, headerDateType: "year" },
  151: { label: "위험성평가회의", isApproval: false, usePrint: true },
  152: { label: "산업안전보건위원회", isApproval: false, usePrint: true },
  153: { label: "노사협의체", isApproval: false, usePrint: true },

  154: { label: "안전보건 예산(B형)", usePrint: true, useHeaderDate: true },
  155: { label: "안전보건 예산(C형)", usePrint: true, useHeaderDate: true },

  156: { label: "종사자 의견 청취", isApproval: false, usePrint: true },
  157: { label: "안전보건 자료", isApproval: false, usePrint: true },
  158: { label: "위험요인 파악", isApproval: false, usePrint: true },
  159: { label: "부서 순회", isApproval: false, usePrint: true },
  160: { label: "유해·위험요인 점검(개선)사항 요청", isApproval: false, usePrint: true },

  161: { label: "정기 위험성평가", isApproval: false, usePrint: true },
  162: { label: "수시 위험성평가", isApproval: false, usePrint: true },

  163: { label: "일일안전보건점검일지", isApproval: false, usePrint: true },
  164: { label: "요양보호사", isApproval: false, usePrint: true },
  165: { label: "종사자 및 주차시설", isApproval: false, usePrint: true },
  166: { label: "냉온수기 및 보일러 설비", isApproval: false, usePrint: true },
  167: { label: "행사자 동선 및 관계자", isApproval: false, usePrint: true },
  168: { label: "시설물 관리(공통)", isApproval: false, usePrint: true },

  169: { label: "시설물 내부", isApproval: false, usePrint: true, presetYearKey: "점검연도", presetPeriodSplit: true },
  170: { label: "시설물 외부 안전점검표", isApproval: false, usePrint: true, presetYearKey: "점검연도", presetPeriodSplit: true },

  171: { label: "부대 시설 안전점검표", isApproval: false, usePrint: true },
  172: { label: "비상설비 안전점검표", isApproval: false, usePrint: true },
  173: { label: "소방용수 탱크 안전점검표", isApproval: false, usePrint: true },
  174: { label: "소방 및 신호기 안전점검표", isApproval: false, usePrint: true },
  175: { label: "주차시설 안전점검표", isApproval: false, usePrint: true },
  176: { label: "기둥, 벽, 보, 천장 안전점검표", isApproval: false, usePrint: true },
  177: { label: "전기시설 안전점검표", isApproval: false, usePrint: true },
  178: { label: "전기 외함 안전점검표", isApproval: false, usePrint: true },
  179: { label: "실외기 및 완강기 안전점검표", isApproval: false, usePrint: true },
  180: { label: "가지치기 안전점검표", isApproval: false, usePrint: true },
  181: { label: "진드기 및 질병예방 안전점검표", isApproval: false, usePrint: true },
  182: { label: "산불예방감시 안전점검표", isApproval: false, usePrint: true },
  183: { label: "풀베기 안전점검표", isApproval: false, usePrint: true },
  184: { label: "산불진화작업 안전점검표", isApproval: false, usePrint: true },
  185: { label: "청원경찰 안전점검표", isApproval: false, usePrint: true },
  186: { label: "청소차량 및 환경미화원 안전점검표", isApproval: false, usePrint: true },
  187: { label: "청소차량 안전점검표", isApproval: false, usePrint: true },
  188: { label: "근로자 건강관리(공통) 안전점검표", isApproval: false, usePrint: true },
  189: { label: "밀폐공간 작업 안전점검표", isApproval: false, usePrint: true },
  190: { label: "유해화학물질 작업 안전점검표", isApproval: false, usePrint: true },
  191: { label: "중량물 작업 시 안전점검 안전점검표", isApproval: false, usePrint: true },
  192: { label: "작업장 바닥 작업 안전점검표", isApproval: false, usePrint: true },
  193: { label: "외벽 청소 작업 안전점검표", isApproval: false, usePrint: true },
  194: { label: "쓰레기 수거 작업 안전점검표", isApproval: false, usePrint: true },
  195: { label: "화기·용접 작업 안전점검표", isApproval: false, usePrint: true },
  196: { label: "급식 점검표 안전점검표", isApproval: false, usePrint: true },
  197: { label: "응급조치 안전점검표", isApproval: false, usePrint: true },
  198: { label: "계절성 업무에 따른 관리대책 안전점검표", isApproval: false, usePrint: true },
  199: { label: "사다리 작업 안전점검표", isApproval: false, usePrint: true },
  200: { label: "근골격계 질환 안전점검표", isApproval: false, usePrint: true },
  201: { label: "안전보건교육 안전점검표", isApproval: false, usePrint: true },
  202: { label: "위험작업별 안전점검표", isApproval: false, usePrint: true },
  203: { label: "기계식 주차설비 작업 안전점검표", isApproval: false, usePrint: true },
  204: { label: "청소(미화) 점검표 안전점검표", isApproval: false, usePrint: true },
  205: { label: "복도 및 화장실청소 안전점검표", isApproval: false, usePrint: true },
  206: { label: "승강기 작업 안전점검표", isApproval: false, usePrint: true },
  207: { label: "전기작업 안전점검표", isApproval: false, usePrint: true },
  208: { label: "위험대비 매뉴얼 대응조치 점검표", isApproval: false, usePrint: true },
  209: { label: "작업장 합동점검 안전점검표", isApproval: false, usePrint: true },
  210: { label: "건설기계·장비별 안전점검표", isApproval: false, usePrint: true },
  211: { label: "예초기 작업 안전점검표", isApproval: false, usePrint: true },
  212: { label: "기계톱 작업 안전점검표", isApproval: false, usePrint: true },
  213: { label: "곤돌라 작업 안전점검표", isApproval: false, usePrint: true },
  214: { label: "지게차 안전점검표 안전점검표", isApproval: false, usePrint: true },

  216: { label: "떨어짐 안전점검표", isApproval: false, usePrint: true },
  217: { label: "물체에 맞음 안전점검표", isApproval: false, usePrint: true },
  218: { label: "무너짐 안전점검표", isApproval: false, usePrint: true },
  219: { label: "(건설현장) 건설기계·장비별 안전점검표", isApproval: false, usePrint: true },
  220: { label: "(건설현장) 위험작업별 안전점검표", isApproval: false, usePrint: true },
  221: { label: "(건설현장) 공정별 안전점검표", isApproval: false, usePrint: true },
  222: { label: "헬스장 안전점검표", isApproval: false, usePrint: true },
  223: { label: "실내체육관 안전점검표", isApproval: false, usePrint: true },
  224: { label: "다목적실 안전점검표", isApproval: false, usePrint: true },
  225: { label: "스트레칭실 안전점검표", isApproval: false, usePrint: true },
  226: { label: "다목적 체육관 안전점검표", isApproval: false, usePrint: true },
  227: { label: "샤워실 안전점검표", isApproval: false, usePrint: true },
  228: { label: "탈의실 안전점검표", isApproval: false, usePrint: true },
  229: { label: "보도 육교 안전점검표", isApproval: false, usePrint: true },
  230: { label: "보도 육교 승강기 안전점검표", isApproval: false, usePrint: true },
  231: { label: "제방 안전점검표", isApproval: false, usePrint: true },
  232: { label: "방파제 안전점검표", isApproval: false, usePrint: true },
  233: { label: "어린이집 안전점검표", isApproval: false, usePrint: true },

  234: { label: "시설물 진단", isApproval: false, usePrint: true },
  235: { label: "시설물 보수", isApproval: false, usePrint: true },
  236: { label: "시설물 보강", isApproval: false, usePrint: true },
  237: { label: "시설물 교체", isApproval: false, usePrint: true },

  238: { label: "(재해발생) 비상조치 및 처리 절차 안내", isApproval: false, usePrint: true },
  239: { label: "비상대피 훈련", isApproval: false, usePrint: true },
  240: { label: "비상대피 교육", isApproval: false, usePrint: true },
  241: { label: "비상대피 자체평가", isApproval: false, usePrint: true },
  242: { label: "비상조치계획 수립", isApproval: false, usePrint: true },
  243: { label: "관계수급인 안전보건 조치 확인 및 조정", isApproval: true, usePrint: true },

  244: { label: "중대재해 발생 보고", isApproval: false, usePrint: true },
  245: { label: "사고발생 및 재발방지계획서", isApproval: false, usePrint: true },

  246: { label: "안전작업계획서(고위험작업)", isApproval: false, usePrint: true },
  247: { label: "위험작업", isApproval: true, usePrint: true },
  248: { label: "일반작업", isApproval: true, usePrint: true },
  249: { label: "기타작업", isApproval: true, usePrint: true },
  250: { label: "산업안전보건관리비", isApproval: true, usePrint: true, useHeaderDate: true },

  251: { label: "현장근로자 정보", isApproval: false, usePrint: true },
  252: { label: "환경보전비", isApproval: true, usePrint: true, useHeaderDate: true },
  253: { label: "아차사고 사례", isApproval: true, usePrint: true },
  254: { label: "아차사고 사례 개선 확인", isApproval: true, usePrint: true },
  255: { label: "아차사고 D/B", isApproval: true, usePrint: true },
  256: { label: "최초 위험성평가", isApproval: true, usePrint: true },
  257: { label: "작업허가서", isApproval: false, usePrint: true },
  258: { label: "안전작업계획서", isApproval: true, usePrint: true },
  259: { label: "안전보건(도급)협의체", isApproval: true, usePrint: true },
  260: { label: "노사협의체", isApproval: true, usePrint: true },
  261: { label: "공사일보", isApproval: false, usePrint: true, useDelete: false, useHeaderDate: false },
  262: { label: "본사 안전보건 점검", isApproval: true, usePrint: true },
  263: { label: "자율안전점검 컨설팅", isApproval: false, usePrint: true },
  264: { label: "외부기관 안전보건 점검", isApproval: true, usePrint: true },
  265: { label: "작업장 순회점검일지(일일안전보건교육)", isApproval: true, usePrint: true },
  266: { label: "안전업무일지", isApproval: true, usePrint: true },
  267: { label: "노사 합동안전보건 점검", isApproval: true, usePrint: true },
  268: { label: "최초 위험성평가", isApproval: true, usePrint: true },
  269: { label: "위험성평가회의록", isApproval: true, usePrint: true },
  270: { label: "정기 위험성평가", isApproval: true, usePrint: true },
  271: { label: "위험성평가회의록", isApproval: true, usePrint: true },
  272: { label: "수시 위험성평가", isApproval: true, usePrint: true },
  273: { label: "위험성평가회의록", isApproval: true, usePrint: true },
  274: { label: "작업허가서", isApproval: true, usePrint: true },
  275: { label: "재해전통", isApproval: true, usePrint: true },
  276: { label: "사고보고서(현장)", isApproval: true, usePrint: true },
  277: { label: "사고원인 및 대책보고사(현장)", isApproval: true, usePrint: true },
  278: { label: "재해발생원인 및 재발방지계획(현장)", isApproval: true, usePrint: true },
  279: { label: "안전작업계획서", isApproval: true, usePrint: true, useHeaderDate: true },
  280: { label: "안전작업계획서", isApproval: true, usePrint: true, useHeaderDate: false },
  281: { label: "테이블아이템", isApproval: true, usePrint: true, useHeaderDate: false },
  282: { label: "안전보건관리책임자 선임", isApproval: false, usePrint: true, hidePrintTitle: true },
  283: { label: "안전보건조정자 선임", isApproval: true, usePrint: true },
  284: { label: "현장대리인 안전보건 경영방침 작성", isApproval: true, usePrint: true },
  285: { label: "안전보건관리(총괄)책임자 선임", isApproval: false, usePrint: true, hidePrintTitle: true },
  286: { label: "안전보건(총괄)관리책임자 업무수행평가표", isApproval: false, usePrint: true, useHeaderDate: false },
  287: { label: "관리감독자 업무수행평가표", isApproval: false, usePrint: true, useHeaderDate: true, headerDateType: "year"  },
  288: { label: "근로자 현장점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  289: { label: "안전보건 순회점검표(사무실)", isApproval: false, usePrint: true, useHeaderDate: false },
  290: { label: "보건 순회점검표(현장)", isApproval: false, usePrint: true, useHeaderDate: false },
  291: { label: "안전 순회점검표(현장)", isApproval: false, usePrint: true, useHeaderDate: false },
  292: { label: "근골격계 증상조사표(근로자)", isApproval: false, usePrint: true, useHeaderDate: false },
  293: { label: "근골격계부담작업 체크리스트", isApproval: false, usePrint: true, useHeaderDate: false },
  294: { label: "중대시민재해 이행사항 점검표 1", isApproval: false, usePrint: true, useHeaderDate: false },
  295: { label: "중대시민재해 이행사항 점검표 2", isApproval: false, usePrint: true, useHeaderDate: false },
  296: { label: "동청사 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  297: { label: "관리감독자 선임", isApproval: false, usePrint: true, useHeaderDate: false },
  298: { label: "관리감독자 선임", isApproval: false, usePrint: true, useHeaderDate: false },
  299: { label: "종사자 정보", isApproval: false, usePrint: true, useHeaderDate: false },
  300: { label: "직영사업장", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true, byCurrentLocation: true },
  301: { label: "도급·용역·위탁 사업장", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true, byCurrentLocation: true },
  302: { label: "신규 사업장 등록 요청", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true, byCurrentLocation: true },
  303: { label: "신규 시설물 등록 요청", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true, byCurrentLocation: true },
  304: { label: "유관기관 비상연락망", isApproval: false, usePrint: true, useHeaderDate: false },
  305: { label: "안전검사 대상 기계·기구 종류 및 검사주기", isApproval: false, usePrint: true, useHeaderDate: false },
  306: { label: "근골격계부담작업", isApproval: false, usePrint: true, useHeaderDate: false },
  307: { label: "산업재해 발생 보고서", isApproval: false, usePrint: true, useHeaderDate: false },
  308: { label: "중대재해 재발방지 조치 보고서", isApproval: false, usePrint: true, useHeaderDate: false },
  309: { label: "안전·보건 조직 체계도", usePrint: true },
  310: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  311: { label: "수급업체별 안전계획", isApproval: false, usePrint: true, useHeaderDate: false },
  312: { label: "시설물 정기 안전 점검", isApproval: false, usePrint: true, useHeaderDate: false },
  313: { label: "유해위험요인 파악 및 보완", isApproval: false, usePrint: true, useHeaderDate: false },
  314: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  315: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  316: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  317: { label: "총괄부서 중대시민재해 종합계획", isApproval: false, usePrint: true, useHeaderDate: false },
  318: { label: "특수건강진단", isApproval: false, usePrint: true, useHeaderDate: false },
  319: { label: "안전보건관리체계 구축 현황(중대시민재해)", isApproval: false, usePrint: true, useHeaderDate: false },
  320: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  321: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  322: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  323: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  324: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  325: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  326: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  327: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  328: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  329: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  330: { label: "테이블아이템", isApproval: false, usePrint: true, useHeaderDate: false },
  337: { label: "부서별 안전계획", isApproval: false, usePrint: true, useHeaderDate: false },
  338: { label: "시설물 안전 인력", isApproval: false, usePrint: true, useHeaderDate: false },
  345: { label: "중대재해 발생 보고(건설업)", isApproval: true, usePrint: true, hidePrintTitle: true },
  346: { label: "중대재해 발생 보고", isApproval: false, usePrint: true, hidePrintTitle: true },
  348: { label: "시설물", isApproval: false, usePrint: true, useHeaderDate: false },
  349: { label: "원료·제조물 사업장", isApproval: false, usePrint: true, useHeaderDate: false },
  350: { label: "직영시설물 안전점검 이행", isApproval: false, usePrint: true, useHeaderDate: false },
  351: { label: "위탁시설물 안전종합점검 이행", isApproval: false, usePrint: true, useHeaderDate: false },
  352: { label: "동절기 대비 시설물 등 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  353: { label: "우기대비 시설물 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  354: { label: "해빙기 시설물 등 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  355: { label: "(사업장)유해·위험요인 점검", isApproval: false, usePrint: true, useHeaderDate: false },
  356: { label: "법정의무교육 이수 현황", isApproval: false, usePrint: true },

  358: { label: "종사자 정보", isApproval: false, usePrint: true, useHeaderDate: false },
  359: { label: "원료·제조물 사업장", isApproval: false, usePrint: true, useHeaderDate: false, hideFileDownload: true, byCurrentLocation: true },

  360: { label: "수급업체 계약정보", isApproval: true, usePrint: true },
  361: { label: "유소견자 사후관리", isApproval: false, usePrint: true },
  362: { label: "유소견자 건강 상담 실적 통계", isApproval: false, usePrint: true },
  363: { label: "사후관리 안내문", isApproval: false, usePrint: true },
  364: { label: "보건관리 계획", isApproval: false, listType: "list364" },
  365: { label: "의약품 지급 현황", isApproval: false, usePrint: true },
  366: { label: "의료기구 점검 현황", isApproval: false, usePrint: true },
  367: { label: "뇌심혈관질환 발병위험도 평가 및 사후관리 절차 개요", isApproval: false, usePrint: true },
  368: { label: "뇌심혈관질환 발병위험도평가자료 종합조사표", isApproval: false, usePrint: true },
  369: { label: "뇌심혈관질환발병위험도에 따른 업무적합성 평가서", isApproval: false, usePrint: true },
  370: { label: "관련자료", isApproval: false, usePrint: true },
  372: { label: "아차사고 등록", isApproval: false, usePrint: true },
  373: { label: "근거법령", usePrint: true },
  374: { label: "평가절차 및 기준", usePrint: true },
  375: { label: "중대시민재해 예방을 위해 필요한 비용의 예시", usePrint: true },
  376: { label: "수급업체 안전보건 평가표", usePrint: true },

  377: { label: "TBM(작업 전 안전점검회의)", isApproval: false, usePrint: true },
  378: { label: "TBM 실행 체크리스트", isApproval: false, usePrint: true },
  379: { label: "(시설물)유해·위험요인 개선 계획", isApproval: false, usePrint: true },
  380: { label: "(부서별 관리 시설물)유해·위험요인 개선 계획", isApproval: false, usePrint: true },
  381: { label: "(위탁 시설물)유해·위험요인 개선 계획", isApproval: false, usePrint: true },
  382: { label: "(사업장)유해·위험요인 개선 계획", isApproval: false, usePrint: true },
  383: { label: "(부서별 관리 사업장)유해·위험요인 개선 계획", isApproval: false, usePrint: true },
  384: { label: "(수급업체 사업장)유해·위험요인 개선 계획", isApproval: false, usePrint: true },
  385: { label: "동절기 대비 시설물 등 안전점검표", isApproval: false, usePrint: true },
  386: { label: "동절기 대비 시설물 등 안전점검표", isApproval: false, usePrint: true },
  387: { label: "(부서별 관리 사업장)유해·위험요인 점검", isApproval: false, usePrint: true },
  388: { label: "(수급업체 사업장)유해·위험요인 점검", isApproval: false, usePrint: true },
  389: { label: "안전보건관리계획서", isApproval: false, usePrint: true },
  390: { label: "유해위험방지계획서", isApproval: false, usePrint: true },
  391: { label: "안전보건 순회점검 보고서", isApproval: false, usePrint: true, hideFileDownload: false, hidePrintTitle: true },
  392: { label: "우기대비 시설물 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  393: { label: "우기대비 시설물 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  394: { label: "해빙기 시설물 등 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  395: { label: "해빙기 시설물 등 안전점검표", isApproval: false, usePrint: true, useHeaderDate: false },
  396: { label: "근골격계 작업환경 개선 계획서", isApproval: false, usePrint: true, useHeaderDate: false },
  397: { label: "MSDS(Material Safety Data Sheet) 리스트 관리", usePrint: true },
  398: { label: "안전보건 일정표", usePrint: true, listType: "list398" },
  399: { label: "화학물질 관리대장", usePrint: true },
  400: { label: "화학물질(작업환경측정 대상) 취급대장", usePrint: true },
  401: { label: "안전작업계획서(장비작업)", usePrint: true },
  402: { label: "안전·보건 순회점검 결과서", isApproval: false, usePrint: true, useHeaderDate: false },

  409: { label: "(원료·제조물)안전보건 예산", usePrint: true, useHeaderDate: true },

  433: { label: "종사자 등록", isApproval: false, usePrint: true, useHeaderDate: false, useExcelDownload: false, hideFileDownload: true, useSelectExcelDownload: true, useListExcelDownload: true },
  434: { label: "안전·보건 교육", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },

  436: { label: "유관기관 비상연락망", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },

  438: { label: "휴게시설 주요 체크리스트", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: false },

  440: { label: "안전·보건관리자 및 산업보건의 선임", isApproval: false, usePrint: true, useHeaderDate: false },

  442: { label: "종사자별 교육 이수 현황", isApproval: false, usePrint: true, useHeaderDate: false },
  443: { label: "재발방지 조치 보고서", isApproval: true, usePrint: true, useHeaderDate: false },
  447: { label: "MSDS 리스트 관리", usePrint: true, useHeaderDate: false },
  450: { label: "위험성평가", usePrint: true },
  453: { label: "안전·보건 조직체계도(총괄)", isApproval: false, usePrint: true },

  456: { label: "종사자 정보", isApproval: false, usePrint: true, useHeaderDate: false },

  470: { label: "정기 근골격계 증상조사표(근로자)", isApproval: false, usePrint: true, useHeaderDate: false },
  471: { label: "수시 근골격계 증상조사표(근로자)", isApproval: false, usePrint: true, useHeaderDate: false },

  461: { label: "안전보건 인력 현황", isApproval: false, usePrint: true },

  473: { label: "종사자 설문조사", isApproval: false, usePrint: true },

  478: { label: "(공중교통수단)안전보건 예산", isApproval: false, usePrint: true },
  479: { label: "(공중(다중)이용시설)안전보건 예산", isApproval: false, usePrint: true },
  480: { label: "(공중교통수단)안전·보건 확보 의무", isApproval: false, usePrint: true },
  481: { label: "(공중(다중)이용시설)안전·보건 확보 의무", isApproval: false, usePrint: true },
  482: { label: "안전·보건 관리 계획서", isApproval: false, usePrint: true },
  483: { label: "종사자 정보", isApproval: false, usePrint: true },

  492: { label: "유관기관 비상연락망", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },
  495: { label: "안전·보건 경영방침", isApproval: false, usePrint: true, useHeaderDate: false },
  508: { label: "TBM(작업 전 안전 미팅일지)", isApproval: false, usePrint: true },
  511: { label: "안전보건총괄책임자 선임", isApproval: false, usePrint: true, hidePrintTitle: true },

  512: { label: "근골격계 부담작업 유해·위험요인조사표", isApproval: false, usePrint: true, useHeaderDate: false },
  513: { label: "근골격계질환 증상조사표(근로자)", isApproval: false, usePrint: true, useHeaderDate: false },
  514: { label: "근골격계부담작업 체크리스트", isApproval: false, usePrint: true, useHeaderDate: false },
  515: { label: "근골격계 부담작업 유해·위험요인조사표", isApproval: false, usePrint: true, useHeaderDate: false },
  516: { label: "근골격계질환 증상조사표(근로자)", isApproval: false, usePrint: true, useHeaderDate: false },
  517: { label: "근골격계부담작업 체크리스트", isApproval: false, usePrint: true, useHeaderDate: false },
  518: { label: "작업환경측정", isApproval: false, usePrint: true, useHeaderDate: false, hidePrintTitle: true },

  520: { label: "사업장 안전보건 총괄 책임자 선임", isApproval: false, usePrint: true, hidePrintTitle: true },
  521: { label: "사업장 안전보건관리(총괄)책임자 선임", isApproval: false, usePrint: true, hidePrintTitle: true },

  533: { label: "유해·위험요인 점검(개선)사항 요청", isApproval: false, usePrint: true },
  534: { label: "관리감독자 수행업무 일지", isApproval: false, usePrint: true, hidePrintTitle: true },

  598: { label: "정기·정밀안전점검", isApproval: false, usePrint: true },
  612: { label: "공지사항(팝업관리)", isApproval: false, usePrint: false, hideFileDownload: true },
  613: { label: "유해·위험요인 점검 체크리스트", isApproval: false, usePrint: true, hidePrintTitle: true, presetYearKey: "점검연도", presetPeriodSplit: true },
  614: { label: "급식소", isApproval: false, usePrint: false },
  615: { label: "(원료·제조물)안전보건 예산", usePrint: true, useHeaderDate: false },
  616: { label: "도서관", isApproval: false, usePrint: false },
  617: { label: "박물관 및 미술관", isApproval: false, usePrint: false },
  618: { label: "의료기관", isApproval: false, usePrint: false },
  619: { label: "어린이집", isApproval: false, usePrint: false },
  620: { label: "업무시설", isApproval: false, usePrint: false },
  621: { label: "실내공연장", isApproval: false, usePrint: false },
  622: { label: "둘이상용도건축물", isApproval: false, usePrint: false },
  623: { label: "건축물", isApproval: false, usePrint: false },
  624: { label: "항만", isApproval: false, usePrint: false },
  625: { label: "교량", isApproval: false, usePrint: false },
  626: { label: "터널", isApproval: false, usePrint: false },
  627: { label: "옹벽 및 절토사면", isApproval: false, usePrint: false },
  628: { label: "도서관", isApproval: false, usePrint: false },
  629: { label: "박물관 및 미술관", isApproval: false, usePrint: false },
  630: { label: "의료기관", isApproval: false, usePrint: false },
  631: { label: "어린이집", isApproval: false, usePrint: false },
  632: { label: "업무시설", isApproval: false, usePrint: false },
  633: { label: "실내공연장", isApproval: false, usePrint: false },
  634: { label: "둘이상용도건축물", isApproval: false, usePrint: false },
  635: { label: "건축물", isApproval: false, usePrint: false },
  636: { label: "항만", isApproval: false, usePrint: false },
  637: { label: "교량", isApproval: false, usePrint: false },
  638: { label: "터널", isApproval: false, usePrint: false },
  639: { label: "옹벽 및 절토사면", isApproval: false, usePrint: false },
  640: { label: "중대시민재해 발생 보고서", isApproval: false, usePrint: false },
  641: { label: "중대시민재해 조치 보고서", isApproval: false, usePrint: false },
  642: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  643: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  644: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  645: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  646: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  647: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  648: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  649: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  650: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  651: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  652: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  653: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  654: { label: "유해·위험요인 발생 및 조치현황", isApproval: false, usePrint: false },
  655: { label: "재발방지계획서", isApproval: false, usePrint: false },
  656: { label: "교육 이수 계획 및 현황", isApproval: false, usePrint: false },
  661: { label: "(공중(다중)이용시설)안전보건 예산", isApproval: false, usePrint: true },

  664: { label: "안전보건", isApproval: false, usePrint: true },
  665: { label: "종사자 의견 청취", isApproval: false, usePrint: true },

  667: { label: "위험기계·기구 보유현황", isApproval: false, usePrint: true },

  671: { label: "위험성평가회의", isApproval: false, usePrint: true },
  672: { label: "정기 위험성평가", isApproval: false, usePrint: true },
  673: { label: "수시 위험성평가", isApproval: false, usePrint: true },

  685: { label: "공중이용시설" },
  686: { label: "원료·제조물" },

  881: { label: "반기별 보고 이행 현황", isApproval: false, usePrint: true },

  886: { label: "회의록", isApproval: false, usePrint: true },

  1015: { label: "청력보존프로그램평가", isApproval: false, usePrint: true },
  1016: { label: "밀폐공간 작업 프로그램 평가", isApproval: false, usePrint: true, visibleFileDownload: true },
  1017: { label: "개인보호구 지급 대장", isApproval: false, usePrint: true, useHeaderDate: true, headerDateType: "yearMonth" },
  1018: { label: "작업환경측정 결과", isApproval: false, usePrint: true },
  1019: { label: "보건관리 대행기관", isApproval: false, usePrint: true },
  1020: { label: "안전검사 기계기구 리스트", isApproval: false, usePrint: true },
  1021: { label: "밀폐공간 안전보건 작업계획서", isApproval: false, usePrint: true },
  1022: { label: "밀폐공간 안전보건 작업허가서", isApproval: false, usePrint: true },

  1032: { label: "결과등록", isApproval: false, usePrint: true },

  1037: { label: "사후관리소견서 등록", isApproval: false, usePrint: true },

  1039: { label: "보호구 수불대장", isApproval: false, usePrint: true, useHeaderDate: true, headerDateType: "year" },
  1044: { label: "안전관리 의무사항 이행 자체점검 결과", isApproval: false, usePrint: true, multiPrint: false, emptyLayoutPrint: true, presetYearKey: "점검연도", presetPeriodKey: "구분", presetHeaderYear: true },

  1045: { label: "수시점검(해빙기 등)", isApproval: false, usePrint: true, presetFieldKey: "점검대상시설명", presetYearKey: "점검연도", presetPeriodKey: "점검구분" },
  1046: { label: "안전계획 수립", isApproval: false, usePrint: true, useHeaderDate: true, headerDateType: "year", emptyLayoutPrint: true },
  1054: { label: "조치사항", isApproval: false, usePrint: false, useHeaderDate: false },

  1060: { label: "안전계획 등록", isApproval: false, usePrint: false, visibleFileDownload: true, presetYearKey: "year" },

  1067: { label: "정기 위험성평가 (MIRAS)", isApproval: false },

  1076: { label: "순회점검표", isApproval: false, usePrint: false },
  1077: { label: "합동점검표", isApproval: false, usePrint: false },
  1078: { label: "도급사업점검표 2", isApproval: false, usePrint: false },
  1079: { label: "도급사업점검표 1", isApproval: false, usePrint: false },

  1081: { label: "안전보건협의체", isApproval: false, usePrint: false, useHeaderDate: true, headerDateType: "yearMonth" },
  1082: { label: "적격 수급업체 선정 가이드라인", isApproval: false, usePrint: true },
  1083: { label: "반기별 보고", isApproval: false, usePrint: true, useHeaderDate: true, headerDateType: "year" },
  1084: { label: "안전·보건 확보 의무 ", isApproval: false, usePrint: true, useHeaderDate: true, headerDateType: "year" },

  1090: { label: "밀폐공간 작업 질식재해 예방 자체점검표", isApproval: false, usePrint: true },
  1092: { label: "도급사업점검표", isApproval: false, usePrint: false },
  1093: { label: "반기별 보고 이행 현황", isApproval: false, usePrint: true },
  1108: { label: "자료실", isApproval: false, usePrint: true, useSideConfig: true },
  1115: { label: "MSDS 관리 이행 점검표", isApproval: false, usePrint: true },

  1129: { label: "보험 등록", isApproval: false, usePrint: false, visibleFileDownload: true, presetYearKey: "year" },

  1155: { label: "체크리스트 등록 현황", isApproval: false },
  1156: { label: "내부 등록현황", isApproval: false },
  1187: { label: "외부 등록현황", isApproval: false },
  1234: { label: "3단계 판단법(MIRAS)", isApproval: false, usePrint: true, useHeaderDate: true },
  1237: { label: "수시 근골격계 부담작업 유해요인조사", isApproval: false, usePrint: true, useHeaderDate: false },
};
